import { render, staticRenderFns } from "./WUidField.vue?vue&type=template&id=08bedc0a&"
import script from "./WUidField.vue?vue&type=script&lang=js&"
export * from "./WUidField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./WUidField-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ffields%2FWUidField.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports